import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import SaleDetailsPopup from './SaleDetailsPopup';
import BannerText from './BannerText';

const Wrapper = styled.div`
  background: ${props => props.theme.old ? props.theme.colors.french : props.theme.colors.newPromo };
  position: relative;

  .banner-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3px;

    .copy {
      text-align: center;
      color: white;
       // color: ${props => props.theme.old ? 'white' : props.theme.colors.charcoal };

    }
  }

  .banner-txt {
    text-align: center;
    // color: ${props => props.theme.old ? 'white' : props.theme.colors.charcoal };
    color: white;
  }

  .details-link {
    // color: ${props => props.theme.old ? 'white' : props.theme.colors.charcoal };
    color: white;
     text-decoration: underline;
  }

  .sale-page-link, .see-details-btn {
    // color: ${props => props.theme.old ? 'white' : props.theme.colors.charcoal };
    color: white;
    // text-decoration: underline;

    &:hover {
      //color: ${props => props.theme.old ? 'white' : props.theme.colors.charcoal };
      color: white;
    }
  }
`;

function NavBannerMobile({ className }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isAdminView = location.pathname.startsWith('/admin');
  const isLeaveReviews =
    location.pathname.startsWith('/reviews') && location.pathname.length > 9;

  const hideMobileBanner = isAdminView || isLeaveReviews;

  if (hideMobileBanner) return null;

  const toggle = () => {
    setOpen(!open);
  };

  return (
    <Wrapper className={className ? className : ''} id="nav-banner-mobile">
      <div className="banner-content">
        <BannerText onClick={toggle} />
      </div>
      <SaleDetailsPopup open={open} toggle={toggle} />
    </Wrapper>
  );
}

export default NavBannerMobile;
